

















































import { mapState } from 'vuex';
import Vue from 'vue';
import { logout } from '@antriver/vue-site-utils/src/util/auth';
import { api, authTokenStore } from '@/services/api';

export default Vue.extend({
    name: 'SideMenu',

    computed: {
        ...mapState('auth', ['currentUser']),

        items() {
            return [
                { title: 'Home', path: '/', icon: 'fas fa-flipboard' },
                { title: 'About', path: '/about', icon: 'fas fa-question' },
                !this.currentUser ? { title: 'Login', path: '/login', icon: 'fas fa-key' } : null,
                !this.currentUser ? { title: 'Signup', path: '/signup', icon: 'fas fa-user-plus' } : null,
            ].filter((i) => i !== null);
        },

        initials() {
            return this.currentUser ? this.currentUser.username.match(/\b(\w)/g).join('').toUpperCase() : null;
        },
    },

    methods: {
        logout() {
            logout(
                api,
                this.$store,
                authTokenStore,
            );

            window.location.reload();
        },
    },
});
